import React, { useState, ReactNode } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  showDot?: boolean;
  className?: string;
  headerClassName?: string;
  headerRight?: ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultExpanded = true,
  showDot = false,
  className = '',
  headerClassName = '',
  headerRight,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={className}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`w-full flex items-center justify-between py-3 px-4 text-left hover:bg-gray-50 rounded transition-colors ${headerClassName}`}
      >
        <div className="flex items-center space-x-2">
          {showDot && <div className="w-2 h-2 bg-[#07E5D1] rounded-full flex-shrink-0"></div>}
          <h3 className="text-base font-medium text-gray-900">{title}</h3>
        </div>
        <div className="flex items-center space-x-2 flex-shrink-0">
          {headerRight && <div onClick={(e) => e.stopPropagation()}>{headerRight}</div>}
          {isExpanded ? (
            <ChevronUp className="h-4 w-4 text-gray-500" />
          ) : (
            <ChevronDown className="h-4 w-4 text-gray-500" />
          )}
        </div>
      </button>

      {isExpanded && <div className="mt-3 pl-4">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
